import { Button } from 'primereact/button'
import utils from '../../index'
import { enums, icons } from '../../../constants'
import React from 'react'
import { Link } from 'react-router-dom'
import { Dropdown } from 'primereact/dropdown'
import { Calendar } from 'primereact/calendar'
import { InputText } from 'primereact/inputtext'
import LtsDropdownUnidade from '../../../components/lottus/lts-dropdown-unidade'
import _ from 'lodash'
import LtsDropdownIdValue from '../../../components/lottus/lts-dropdown-id-value'
import { Checkbox } from 'primereact/checkbox'
import { fuOnBlurValorFormaPagamento } from '../../lancamento-form-utils'
import { Column } from 'primereact/column'
import LtsLookupItemLancamento from '../../../components/lottus/lts-lookup-item-lancamento'

export function formActionPagamento(rowData, formPageContainer) {
  return (
    <div>
      <Button
        type="button"
        tooltip={utils.getMessage(formPageContainer.props.messages, 'lancamentofinanceiro.label.boleto')}
        className="p-button-warning"
        onClick={(e) => formPageContainer.verificarGeracaoBoletoIndividual(rowData)}
        icon={icons.CREDIT_CARD_ICON}
        disabled={formPageContainer.disabledBotaoBoleto(rowData)}
      />
      <Button
        type="button"
        icon={icons.RECEIPT_ICON}
        tooltip={utils.getMessage(formPageContainer.props.messages, 'lancamentofinanceiro.label.promissoria')}
        onClick={(e) => formPageContainer.props.openUrl(rowData.urlPromissoria)}
        disabled={!utils.nonNull(rowData.urlPromissoria) && utils.isStringBlank(rowData.urlPromissoria)}
      />
      <Button
        type="button"
        icon={icons.REMOVE_ICON}
        className="p-button-danger"
        tooltip={utils.getMessage(formPageContainer.props.messages, 'label.remover')}
        onClick={(e) => formPageContainer.props.removerLancamento(rowData, formPageContainer.props.record.lancamentos)}
        disabled={rowData.status === 3 || utils.nonNull(rowData.oidBoletoAilos) || utils.nonNull(rowData.oid)}
      />
    </div>
  )
}

export function formColumnData(rowData, column, formPageContainer, basePath) {
  if (column) {
    if (column.field === 'oid' && rowData[column.field] && rowData[column.field] !== '') {
      return (
        <Link to={`${basePath}/${rowData.oid}`} onClick={(e) => formPageContainer.props.loadById(rowData.oid)}>
          {rowData.oid}
        </Link>
      )
    }
    if (column.field === 'tipoFormaPagamento' && rowData[column.field] !== '') {
      return (
        <Dropdown
          autoWidth={false}
          value={rowData[column.field]}
          options={formPageContainer.props.formasPagamentoBasica}
          onChange={(e) => editarDadoLancamentoFinanceiroFilho(rowData, e, formPageContainer)}
          optionLabel="value"
          optionValue={(v) => v}
          dataKey="value"
          name="tipoFormaPagamento"
          disabled={rowData.status === 4 || rowData.status === 3 || utils.nonNull(rowData.oidBoletoAilos)}
        />
      )
    }
    if (column.field === 'vencimento' && rowData[column.field] !== '') {
      return (
        <Calendar
          yearRange={utils.getYearRangeFromDate('1970')}
          value={rowData[column.field] ? new Date(rowData[column.field]) : new Date()}
          onChange={(e) => editarDadoLancamentoFinanceiroFilho(rowData, e, formPageContainer)}
          name="vencimento"
          disabled={rowData.status === 4 || rowData.status === 3 || utils.nonNull(rowData.oidBoletoAilos)}
        />
      )
    }
    if (column.field === 'valor') {
      return (
        <InputText
          keyfilter={/^[0-9.,]+$/}
          value={getValorReais(rowData[column.field])}
          maxLength={10}
          onBlur={(e) => fuOnBlurValorFormaPagamento(rowData, e, formPageContainer)}
          onChange={(e) => editarDadoLancamentoFinanceiroFilho(rowData, e, formPageContainer)}
          name="valor"
          disabled={rowData.status === 4 || rowData.status === 3 || utils.nonNull(rowData.oidBoletoAilos)}
        />
      )
    }
    if (column.field === 'unidade') {
      return (
        <LtsDropdownUnidade
          name={'unidadeParcela'}
          value={rowData[column.field]}
          onChange={(e) => {
            _.set(rowData, 'unidade', e)
            formPageContainer.setState({ atualizar: true })
          }}
        />
      )
    }
    if (column.field === 'contaCorrente') {
      return (
        <LtsDropdownIdValue
          name={'contaCorrenteParcela'}
          value={rowData[column.field]}
          options={formPageContainer.props.contasCorrentesParcelas}
          onChange={(e) => {
            _.set(rowData, 'contaCorrente', e)
            formPageContainer.setState({ atualizar: true })
          }}
        />
      )
    }
    if (column.field === 'grupoItemPrincipal') {
      return (
        <LtsLookupItemLancamento
          header={'Grupo'}
          value={_.get(rowData[column.field], 'value', null)}
          history={formPageContainer.props.history}
          onChange={(e) => {
            const value = { id: _.get(e, 'oidGrupo', null), value: _.get(e, 'descricao', null) }
            _.set(rowData, 'grupoItemPrincipal', value)
            _.set(rowData, 'oidItemPrincipal', _.get(e, 'oidTipo', null))
            _.set(rowData, 'tipoItemPrincipal', _.get(e, 'tipo', null))
            _.set(rowData, 'tipoGrupoItem', _.get(e, 'entradaSaida', null))
            formPageContainer.setState({ atualizar: true })
          }}
          idUnidade={_.get(rowData, 'unidade.id', null)}
          editHidden={true}
          showValor={false}
        />

        // <LtsLookupGrupoFinanceiro
        //     value={_.get(rowData[column.field], 'value', null)}
        //     editHidden={true}
        //     field={'grupoItemPrincipal'}
        //     multiple={false}
        //     onChange={(e) => {
        //       const value = { id: _.get(e, 'oid', null), value: _.get(e, 'descricao', null) }
        //       _.set(rowData, 'grupoItemPrincipal', value)
        //       formPageContainer.setState({ atualizar: true })
        //     }}
        //   />
      )
    }
    if (column.field === 'promissoria') {
      return (
        <Checkbox
          inputId="chkPromissoria"
          checked={rowData[column.field]}
          onChange={(e) => editarDadoLancamentoFinanceiroFilho(rowData, e, formPageContainer)}
          name="promissoria"
          style={{ textAlign: 'center' }}
        />
      )
    }
    if (column.field === 'status') {
      return <div>{enums.StatusLancamento[rowData[column.field]]}</div>
    }
  }
}

const editarDadoLancamentoFinanceiroFilho = (lancamento, evento, formPageContainer) => {
  const target = evento.target
  const field = target.name
  let valor = target.value
  if (field === 'valor') {
    valor = valor.replace('R$', '')
    if (typeof valor === 'string' && valor.length > 0) {
      valor = valor.trim()
    }
    lancamento['valorBruto'] = valor
  } else if (field === 'promissoria') {
    valor = target.checked
  } else if (field === 'tipoFormaPagamento') {
    // caso troque a forma de pagamento limpa o campo promissoria
    lancamento.promissoria = false
  } else if (field === 'vencimento') {
    lancamento[field] = valor
    ordenarArrayParcelas(formPageContainer)
  }
  lancamento[field] = valor
  formPageContainer.setState({ atualizar: true })
}

const ordenarArrayParcelas = (formPageContainer) => {
  let lancamentosOrdenados = utils.orderArrayByProperty(formPageContainer.props.record.lancamentos, 'vencimento')
  if (!utils.isArrayNullOrEmpty(lancamentosOrdenados)) {
    formPageContainer.props.setField('lancamentos', lancamentosOrdenados)
  }
}

const getValorReais = (valor) => {
  if (valor && valor !== '') {
    return 'R$ ' + valor
  }
  return ''
}

export function formColunasPagamento(formPageContainer, columnData, actionPagamento) {
  return formPageContainer.props.colunasPagamentos.map((col) => {
    if (col.field === 'multiselect') {
      return <Column selectionMode="multiple" style={{ width: '2.5em' }} />
    }
    if (col.field === 'oid') {
      return (
        <Column
          {...col}
          key={col.field}
          field={col.field}
          body={columnData}
          style={{ textAlign: 'center', width: '7em' }}
        />
      )
    }
    if (col.field === 'acoes') {
      return (
        <Column
          {...col}
          key={col.field}
          field={col.field}
          body={actionPagamento}
          style={{ width: '9em' }}
          align={'right'}
          alignHeader={'right'}
        />
      )
    }
    if (
      col.field === 'tipoFormaPagamento' ||
      col.field === 'valor' ||
      col.field === 'vencimento' ||
      col.field === 'unidade' ||
      col.field === 'contaCorrente' ||
      col.field === 'grupoItemPrincipal'
    ) {
      return (
        <Column
          {...col}
          key={col.field}
          field={col.field}
          body={columnData}
          style={{ textAlign: 'center', overflow: 'visible', width: '10em' }}
        />
      )
    }
    if (col.field === 'promissoria') {
      return (
        <Column
          {...col}
          key={col.field}
          field={col.field}
          body={columnData}
          style={{ overflow: 'visible', width: '5em' }}
          align={'right'}
          alignHeader={'right'}
        />
      )
    }
    if (col.field === 'status') {
      return (
        <Column
          {...col}
          key={col.field}
          field={col.field}
          body={columnData}
          style={{ overflow: 'visible', width: '8em' }}
          align={'left'}
          alignHeader={'left'}
        />
      )
    }
    return (
      <Column
        {...col}
        key={col.field}
        field={col.field}
        header={col.header}
        style={{ textAlign: 'center', width: '7em' }}
      />
    )
  })
}

//
export function fuGetValorLancamentosFilhos(formPageContainer) {
  let valorTotalLancamentoFilhos = 0
  if (formPageContainer.props.record.lancamentos && formPageContainer.props.record.lancamentos.length >= 1) {
    formPageContainer.props.record.lancamentos.forEach((lancamentoFilho) => {
      let valor = utils.parseStringToNumber(lancamentoFilho.valor)
      valorTotalLancamentoFilhos += valor
    })
  }
  return valorTotalLancamentoFilhos
}

export function fuDesabilitarBotaoAdicionarPagamento(formPageContainer) {
  let valorTotalLancamento = utils.parseStringToNumber(formPageContainer.props.record.valor)
  let valorTotalLancamentosFilhos = fuGetValorLancamentosFilhos(formPageContainer)
  if (valorTotalLancamentosFilhos >= valorTotalLancamento) {
    return true
  }
  return formPageContainer.props.record.status === 3
}

export function fuDesabilitarBotaoEstornarParcela(formPageContainer) {
  const parcelaPaga = utils.findObjectInArray(formPageContainer.props.selectedParcelas, 'status', 3)
  return !utils.nonNull(parcelaPaga)
}

export function fuDesabilitarBotaoBaixarParcela(formPageContainer) {
  const parcelaPaga = utils.findObjectInArray(formPageContainer.props.selectedParcelas, 'status', 3)
  const parcelaCancelada = utils.findObjectInArray(formPageContainer.props.selectedParcelas, 'status', 4)
  return !(
    !parcelaPaga &&
    !parcelaCancelada &&
    formPageContainer.props.selectedParcelas &&
    formPageContainer.props.selectedParcelas.length > 0
  )
}

export function fuDesabilitarBotaoBoleto(formPageContainer) {
  const boletos = formPageContainer.props.selectedParcelas.filter((p) => p.tipoFormaPagamento.id === 5)
  const parcelaEmAberto = utils.findObjectInArray(boletos, 'status', 3)
  return !(!parcelaEmAberto && boletos && boletos.length > 0)
}

export function fuDesabilitarBotaoCarne(formPageContainer) {
  const carnes = formPageContainer.props.selectedParcelas.filter((p) => p.tipoFormaPagamento.id === 17)
  return !(carnes && carnes.length > 0)
}

export function fuShowFormParcelas(formPageContainer) {
  formPageContainer.props.setDadoFormaPagamento('formaPagamento', formPageContainer.props.record.tipoFormaPagamento)
  if (formPageContainer.props.record.vencimento) {
    formPageContainer.props.setDadoFormaPagamento('primeiroVencimento', formPageContainer.props.record.vencimento)
  } else {
    formPageContainer.props.setDadoFormaPagamento('primeiroVencimento', new Date())
  }
  formPageContainer.props.showForm('pagamento', true)
}

export function fuAbrirLancamento(oidLancamento, formPageContainer, basePath) {
  formPageContainer.props.history.push(`${basePath}/${oidLancamento}`)
  formPageContainer.props.loadById(oidLancamento)
}

export function fuOnChangeItemLancamento(data, formPageContainer) {
  const values = _.get(data, 'values', [])
  const packageDiscount = _.get(data, 'packageDiscount', 0)
  formPageContainer.setField('taxas', values)

  setItemPrincipal(data, formPageContainer)

  //Se tiver nota de entrada não muda o valor
  const oidNotaEntrada = _.get(formPageContainer, 'props.record.notaEntrada.id', null)
  if (!oidNotaEntrada) {
    setTimeout(() => updateValues(values, packageDiscount, formPageContainer), 100)
  }
  setDescricaoServicoNFSe(data, formPageContainer)
}

const setItemPrincipal = (data, formPageContainer) => {
  const values = _.get(data, 'values', [])
  if (utils.isArrayNullOrEmpty(values)) {
    formPageContainer.setField('oidItemPrincipal', null)
    return
  }

  const oidItemPrincipalAtual = _.get(formPageContainer, 'props.record.oidItemPrincipal', null)
  const serviceRemoved = _.get(data, 'serviceRemoved', null)
  const serviceAdded = _.get(data, 'serviceAdded', null)
  if (serviceAdded && !oidItemPrincipalAtual) {
    formPageContainer.setField('oidItemPrincipal', _.get(serviceAdded, 'itemLancamento.oidTipo', null))
    formPageContainer.setField('tipoItemPrincipal', _.get(serviceAdded, 'itemLancamento.tipo', null))
    return
  }

  if (serviceRemoved) {
    const oidTaxaRemoved = _.get(serviceRemoved, 'itemLancamento.oidTipo', null)
    if (oidTaxaRemoved === oidItemPrincipalAtual) {
      formPageContainer.setField('oidItemPrincipal', _.get(values[0], 'itemLancamento.oidTipo', null))
      formPageContainer.setField('tipoItemPrincipal', _.get(values[0], 'itemLancamento.tipo', null))
    }
  }
}

const updateValues = (values, packageDiscount, formPageContainer) => {
  const valorBruto = calcValorBruto(values)
  const valorMulta = calcMulta(valorBruto, formPageContainer)
  const valorJuros = calcJuros(valorBruto)
  const valorDesconto = calcDesconto(valorBruto) + _.defaultTo(packageDiscount, 0)

  const newValue = valorBruto + valorMulta + valorJuros - valorDesconto

  formPageContainer.setField('valorBruto', valorBruto)
  formPageContainer.setField('valor', newValue)

  if (newValue <= 0) {
    formPageContainer.setField('tipoDesconto', '')
    formPageContainer.setField('valorDesconto', '')
    formPageContainer.setField('percentualDesconto', '')
    formPageContainer.setField('tipoJuros', '')
    formPageContainer.setField('valorJuros', '')
    formPageContainer.setField('percentualJuros', '')
    formPageContainer.setField('tipoMulta', '')
    formPageContainer.setField('valorMulta', '')
    formPageContainer.setField('percentualMulta', '')
  } else if (packageDiscount > 0 && newValue >= packageDiscount) {
    // TODO validar isso com Vandir -- emitir mensagem com aviso de desconto do pacote?
    formPageContainer.setField('tipoDesconto', 1) // valor
    formPageContainer.setField('valorDesconto', valorDesconto)
    formPageContainer.setField('percentualDesconto', 0)
  }

  formPageContainer.props.recalcularValorLancamento()
}

const calcValorBruto = (values) => {
  let valorBruto = 0
  if (utils.isArrayNotEmpty(values)) {
    for (const item of values) {
      valorBruto += _.get(item, 'valorTotal', 0)
    }
  }
  return valorBruto
}

const calcMulta = (valorBruto, formPageContainer) => {
  //TODO - valorMulta deve ser currency
  const valorMulta = utils.parseStringToNumber(_.get(formPageContainer, 'props.record.valorMulta', '0'))
  if (valorMulta && valorMulta > 0) {
    return valorMulta
  }

  //TODO - percentualMulta deve ser number
  const percentualMulta = utils.parseStringToNumber(_.get(formPageContainer, 'props.record.percentualMulta', '0'))
  if (percentualMulta && percentualMulta > 0) {
    return (valorBruto * percentualMulta) / 100
  }

  return 0
}

const calcJuros = (valorBruto, formPageContainer) => {
  //TODO - valorJuros deve ser currency
  const valorJuros = utils.parseStringToNumber(_.get(formPageContainer, 'props.record.valorJuros', '0'))
  if (valorJuros && valorJuros > 0) {
    return valorJuros
  }

  //TODO - percentualJuros deve ser number
  const percentualJuros = utils.parseStringToNumber(_.get(formPageContainer, 'props.record.percentualJuros', '0'))
  if (percentualJuros && percentualJuros > 0) {
    return (valorBruto * percentualJuros) / 100
  }

  return 0
}

const calcDesconto = (valorBruto, formPageContainer) => {
  //TODO - valorDesconto deve ser currency
  const valorDesconto = utils.parseStringToNumber(_.get(formPageContainer, 'props.record.valorDesconto', '0'))
  if (valorDesconto && valorDesconto > 0) {
    return valorDesconto
  }

  //TODO - percentualDesconto deve ser number
  const percentualDesconto = utils.parseStringToNumber(_.get(formPageContainer, 'props.record.percentualDesconto', '0'))
  if (percentualDesconto && percentualDesconto > 0) {
    return (valorBruto * percentualDesconto) / 100
  }

  return 0
}

const setDescricaoServicoNFSe = (data, formPageContainer) => {
  const descricaoServicoNFSe = _.get(formPageContainer, 'props.record.descricaoServicoNFSe', null)
  const newValue = _.get(data, 'descricaoServico', null)
  if ((!descricaoServicoNFSe || _.trim(descricaoServicoNFSe).length === 0) && newValue) {
    formPageContainer.setField('descricaoServicoNFSe', newValue)
  }
}

export function fuSetMarcadores(data, formPageContainer) {
  const values = []
  data.forEach((object) => {
    values.push({
      id: _.get(object, 'oid', ''),
      value: _.get(object, 'codigo', ''),
    })
  })
  formPageContainer.props.setField('marcadores', values)
}
